import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import './MultiDeletePopup.scss';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
  },
  confirmButton: {
    color: '#ffffff',
    transition: 'background-color 0.3s',
  },
  confirmButtonClicked: {
    backgroundColor: '#03E67C',
  },
}));

const MultipleDeleteConfirmationPopup = ({
  title,
  subTitle,
  isOpen,
  onClose,
  onConfirm,
  leftButtonName,
  rightButtonName,
}) => {
  const classes = useStyles();
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className={classes.paper}>
        <div className='Multi-delete-popup'>
          <DialogTitle id='alert-dialog-title' className='Multi-delete-popup-title'>
            {title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id='alert-dialog-description'
              className='Multi-delete-popup-subtitle'
            >
              {subTitle}
            </DialogContentText>
          </DialogContent>
        </div>
        <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
          <DialogActions>
            <Button variant='outlined' size='large' color='secondary' onClick={() => onClose()}>
              {leftButtonName}
            </Button>
            <Button
              variant='contained'
              size='large'
              color='primary'
              onClick={() => handleConfirm()}
            >
              {rightButtonName}
            </Button>
          </DialogActions>
        </div>
      </div>
    </Modal>
  );
};

MultipleDeleteConfirmationPopup.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  leftButtonName: PropTypes.string.isRequired,
  rightButtonName: PropTypes.string.isRequired,
};

export default MultipleDeleteConfirmationPopup;
